import React from 'react'
import gql from 'graphql-tag'
import get from 'lodash.get'
import DeliveredUrl from 'components/shared/DeliveredUrl'
import DefaultProductStatus from '../../DefaultProductStatus'
import ProvideInput from './ProvideInput'
import ToggleTeaser from './ToggleTeaser'
import './index.scss'

function getDeliveredUrl(product) {
  const edges = product.assets.edges.filter(({ node }) => {
    if (!node.labels || node.labels.length === 0) return true
    return !node.labels.includes('teaser')
  })
  return get(edges, '[0].node.url')
}

function getDeliveredTeaserUrl(product) {
  const edges = product.assets.edges.filter(({ node }) => {
    if (!node.labels || node.labels.length === 0) return false
    return node.labels.includes('teaser')
  })
  return get(edges, '[0].node.url')
}

const VideoProduct = ({product, viewer}) => {
  if (product.canProvideUserInput) {
    return (
      <ProvideInput
        product={product}
        productAvailability={viewer.broker.productAvailability}
        broker={viewer.broker}
      />
    )
  }

  if (product.state === 'delivered') {
    return (
      <>
        <DeliveredUrl product={product} getDeliveredUrl={getDeliveredUrl} />
        {!!getDeliveredTeaserUrl(product) && (
          <DeliveredUrl
            product={product}
            getDeliveredUrl={getDeliveredTeaserUrl}
            getTexts={() => ({
              product: 'teaser',
              watchProduct: 'Se teaser',
              copiedLink: 'Lenke er kopiert',
              descriptions: [],
            })}
          />
        )}
      </>
    )
  }

  return (
    <>
      <DefaultProductStatus product={product} />
      {product.canOrderTeaser && (
        <ToggleTeaser product={product} />
      )}
    </>
  )
}

VideoProduct.fragment = gql`
  fragment VideoProduct on VideoProduct {
    videoVariant
    teaser
    teaserUnitPrice
    canOrderTeaser
    tasks {id, name, title, completed}
    features {id, name, value, optional}
    facts {id, name, value}
    booking {
      id
      resourceName
    }
    assets {
      edges {
        node {
          id
          state
          ...on UrlAsset {url, labels}
        }
      }
    }
  }
`

export default VideoProduct
